module.exports = __webpack_public_path__ + "static/media/hvammsvirkjun1200.d056afdf.png";